import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { Auth } from '../models/auth';
import { Environment } from '../models/environment.model';
import { ResetDynamicState } from '../stores/dynamic.store';
import { MainState, ResetMainState, SetAuth } from '../stores/main.store';
import { EnvironmentService } from './environment.service';
import { HttpService } from './http.service';

// import * as bcrypt from 'bcryptjs';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private readonly environment: Environment;
  constructor(
    private router: Router,
    private http: HttpService,
    private store: Store,
    environmentService: EnvironmentService
  ) {
    this.environment = environmentService.getEnvironment();
  }

  async login(username: string, password: string): Promise<Auth | null> {
    this.store.dispatch(new ResetMainState());
    return this.http
      .post<Auth, any>(`${this.environment.apiUrl}/auth/token`, { username, password })
      .then((auth: Auth) => {
        this.store.dispatch(new ResetMainState());
        this.store.dispatch(new SetAuth(auth));
        this.startRefreshTokenTimer();
        return auth;
      })
      .catch((error) => {
        return null;
      });
  }

  async logout() {
    const auth = this.store.selectSnapshot(MainState.auth);
    await this.http
      .post<any, any>(`${this.environment.apiUrl}/auth/token/revoke`, null)
      .catch((error) => {})
      .finally(() => {
        this.stopRefreshTokenTimer();
        this.store.dispatch(new ResetDynamicState());
        this.store.dispatch(new ResetMainState());
        this.router.navigate([`${auth?.urlRoute}/login`]);
      });
  }

  refreshToken() {
    return this.http
      .post<Auth, any>(`${this.environment.apiUrl}/auth/token/refresh`, {})
      .then((auth: Auth) => {
        this.store.dispatch(new SetAuth(auth));
        this.startRefreshTokenTimer();
        return auth;
      })
      .catch((error) => {
        this.stopRefreshTokenTimer();
        this.store.dispatch(new ResetMainState());
      });
  }

  // TODO Move to location
  async loginWithIdpLocation(locationRelationId: string) {
    this.store.dispatch(new ResetMainState());
    let queryParams = { customerLocationId: locationRelationId };
    let url = `${this.environment.apiUrl}/idp/location/token/get?${this.http.queryGenerator(queryParams)}`;
    return this.http
      .get<Auth>(url)
      .then(async (auth: Auth) => {
        this.store.dispatch(new ResetMainState());
        this.store.dispatch(new SetAuth(auth));
        this.startRefreshTokenTimer();
        return auth;
      })
      .catch((error) => {});
  }

  // helper methods

  private refreshTokenTimeout: any;

  private startRefreshTokenTimer() {
    const auth = this.store.selectSnapshot(MainState.auth);

    if (auth == null) {
      return;
    }

    // parse json object from base64 encoded jwt token
    const jwtToken = JSON.parse(atob(auth.token.split('.')[1]));

    // set a timeout to refresh the token a minute before it expires
    const expires = new Date(jwtToken.exp * 1000);
    const timeout = expires.getTime() - Date.now() - 60 * 1000;
    this.refreshTokenTimeout = setTimeout(async () => await this.refreshToken(), timeout);
  }

  private stopRefreshTokenTimer() {
    if (this.refreshTokenTimeout == null) {
      return;
    }
    clearTimeout(this.refreshTokenTimeout);
  }
}
